import { createSelector } from '@ngrx/store';

import { getCartLocationNo } from '@shared/state/cart/selectors';
import { orderTypesState } from '@shared/state/orderTypes/selectors/root';

export const hasDownloadedOrderTypesForCurrentCartLocation = createSelector(getCartLocationNo, orderTypesState, (locationNo, orderTypes) => {
    if (!locationNo || !orderTypes?.data?.length) {
        return false;
    }

    return orderTypes.hasSucceeded === true;
});
